import React from 'react'
import styled from 'styled-components';

interface ISectionWrapperProps {
  title: string;
  icon: React.ReactElement;
  children: React.ReactNode | React.ReactNode[];
}

const SectionWrapper = (props: ISectionWrapperProps) => {
  const { title, icon, children } = props;
  return (
    <MainWrapper>
      <HeaderRow>
        <Title>{title}</Title>
        {icon}
      </HeaderRow>
      {children}
    </MainWrapper>
  )
}
const MainWrapper = styled.div`
    background: #fff;
    padding: 0.5em 0.7em;
    display: flex;
        flex-direction: column;
        gap: 0.2em;
    transition: all 0.2s ease;
 
  `;

  const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    outline: none;
    padding: 0.5em 0;
    border-radius: 6px;
  `;

  const Title = styled.h3`
    font-size: 1.1em;
    font-weight: 600;
    color: #297f76;
    margin: 0;
    text-align: right;
  `;

  
export default SectionWrapper